import React from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import {
  FormContainer,
  FormContent,
} from '@/shared/components/ui/form/form.styled';
import { SelectedItemsList } from '@/shared/components/ui/selected-items-list/selected-items-list';
import { TAddResourcesToGroupFormProps } from '@/shared/features/groups/components/add-resources-to-group/add-resources-to-group-form.types';
import {
  getExcludedResourceGroupIds,
  getResourceName,
} from '@/shared/features/groups/components/add-resources-to-group/add-resources-to-group-form.utils';
import { TAddResourcesToGroupInputSchema } from '@/shared/features/groups/components/add-resources-to-group/add-resources-to-group.validation';
import { GroupSelect } from '@/shared/features/groups/components/group-select/group-select';
import { useGroupsConfig } from '@/shared/features/groups/context/groups-config-context';
import { useReadAllResourceGroupsQuery } from '@/shared/redux/api/assets/groups/groups-api';

export const AddResourcesToGroupForm: React.FC<
  TAddResourcesToGroupFormProps
> = ({ resources, handleClose, submitButtonLabel }) => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();
  const { getIcon } = useGroupsConfig().useResourceElements();
  const { data: allGroupsData } = useReadAllResourceGroupsQuery();
  const excludedIds = getExcludedResourceGroupIds(
    resources,
    allGroupsData?.readAllResourceGroups.items,
  );

  const getSelectedItems = () =>
    resources?.map((resource) => ({
      icon: getIcon(resource.__typename),
      name: getResourceName(resource, t('common:unknown')),
    }));

  return (
    <FormContainer>
      <FormContent>
        <GroupSelect<TAddResourcesToGroupInputSchema>
          name="groupId"
          getItemId={(value) => value}
          disabled={isSubmitting}
          label={t('groups:group')}
          required
          groupFilter={(group) => !excludedIds.has(group.groupId)}
        />
        <SelectedItemsList selectedItems={getSelectedItems()} />
      </FormContent>
      <Submit
        onClose={handleClose}
        submitButtonLabel={submitButtonLabel ?? t('common:add')}
      />
    </FormContainer>
  );
};
